import Swiper, {Navigation, Pagination} from 'swiper';

const futureSlider = document.querySelector('.j-future-slider');
const futureSelectors = Array.from(document.querySelectorAll('.j-future-selector'));

if (futureSlider) {
    let slider = {};
    const options = {
        modules      : [Navigation, Pagination],
        loop         : false,
        speed        : 800,
        spaceBetween : 10,
        slidesPerView: 'auto',
        effect       : 'fade',
        pagination   : {
            el  : '.j-future-pagination',
            type: 'custom',
            renderCustom(_, current, total) {
                const newCurrent = current < 10 ? `0${current}` : current;
                const newTotal = total < 10 ? `0${total}` : total;

                return `<span class="slider-control__current">${newCurrent}</span>
                           <span class="slider-control__total">/ ${newTotal}</span>`;
            }
        },
        navigation: {
            nextEl: '.j-future-next',
            prevEl: '.j-future-prev'
        },
        breakpoints: {
            1280: {
                allowTouchMove: false
            }
        }
    };

    slider = new Swiper(futureSlider, options);

    if (futureSelectors.length) {
        futureSelectors.forEach((selector) => {
            selector.addEventListener('click', () => {
                if (selector.classList.contains('is-active')) {
                    return;
                }

                const newSlide = selector.dataset.selector - 1;

                slider.slideTo(newSlide, 1);
            });
        });
    }

    slider.on('slideChange', (swiper) => {
        const newSlide = document.querySelector(`.j-future-selector[data-selector="${swiper.activeIndex + 1}"]`);

        if (document.querySelector('.j-future-selector.is-active')) {
            document.querySelector('.j-future-selector.is-active').classList.remove('is-active');
        }

        if (newSlide) {
            newSlide.classList.add('is-active');
        }
    });
}
